import gql from 'graphql-tag';
import { uniqueId } from 'lodash';

import type { DetectedBrandTerm } from 'src/data/brandTerm';
import {
  executeGqlMutation,
  type GqlCallVariables,
  type GqlMutationOptions,
} from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_DETECTED_BRAND_TERM } from './schema';

const MUTATION = gql`
  mutation DetectBrandTerms($brandVoiceIds: [ID!]!, $texts: [String!]!) {
    detectBrandTerms(brandVoiceIds: $brandVoiceIds, texts: $texts) {
      ...DetectedBrandTerm
    }
  }
  ${FRAGMENT_DETECTED_BRAND_TERM}
`;

interface Variables extends GqlCallVariables {
  brandVoiceIds: ID[];
  text: string;
}

export const detectBrandTerms = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
): Promise<DetectedBrandTerm[]> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      brandVoiceIds: variables.brandVoiceIds,
      texts: [variables.text],
    },
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });

  const data = getSingleProp<DetectedBrandTerm[][]>(result.data);
  const firstRow = data?.[0];
  return prepareDetectedTerms(firstRow);
};

const prepareDetectedTerms = (
  detectedTerms?: DetectedBrandTerm[]
): (DetectedBrandTerm & { id: ID })[] => {
  if (!detectedTerms) {
    return [];
  }

  return detectedTerms.map((item) => ({
    ...item,
    id: uniqueId('detected_term_'),
  }));
};
